import { useState, useRef, useEffect } from "react"
import { Formik, Field, Form } from "formik"
import {
    InputGroup,
    Label,
    Wrapper,
    CombineInputGroup,
} from "../../Styles/InputStyles"
import { toast } from "react-toastify"
import tw from "tailwind-styled-components"
import { Checkbox, FormControlLabel, FormControl, Select, MenuItem } from "@mui/material"
import { FaCheck } from "react-icons/fa"
import { gracePeriod } from "../../../helpers"

const PropertyFineDetail = ({
    editFineDetailsLoading,
    editFineDetailsMutate,
    apiData
}) => {

    const formikRef = useRef(null)
    const [height, setHeight] = useState(window.innerHeight)

    // const gracePeriodOptions = [
    //     { label: "3 days", value: 3 },
    //     { label: "5 days", value: 5 },
    //     { label: "7 days", value: 7 },
    // ];

    const fineOptions = [
        { label: "Yes", value: 1 },
        { label: "No", value: 2 },
    ];

    const fineTypeOptions = [
        { label: "One Time", value: 1 },
        { label: "Daily", value: 2 },
    ];

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight)
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    const initialValues = {
        gracePeriod: apiData?.property?.gracePeriod || "",
        fine: apiData?.property?.fine ? 1 : 2 || "",
        fineAmount: apiData?.property?.fine || "",
        fineType: apiData?.property?.fineType || "",
        updateTenant: false,
    };

    const handleSubmit = (values) => {
        const amountDepositRegex = /^\d{1,4}$/;
        const maxAmountDeposit = 10000;

        if (!values.gracePeriod || !values.fine) {
            toast.error("All fields are required");
            return;
        }

        if (values.fine === 1) {
            if (!values.fineAmount) {
                toast.error("Fine amount is required");
                return;
            }
            if (values.fineAmount <= 0) {
                toast.error("Fine amount must be positive");
                return;
            }
            if (!amountDepositRegex.test(values.fineAmount) || parseInt(values.fineAmount) > maxAmountDeposit) {
                toast.error("Amount deposit must be between 1 and 10,000 and contain only numbers");
                return;
            }
            if (!values.fineType) {
                toast.error("Fine type is required");
                return;
            }
        }

        editFineDetailsMutate({
            propId: apiData?.property?.id,
            gracePeriod: values.gracePeriod,
            fine: values?.fine === 1 ? Number(values.fineAmount) : 0,
            fineType: values?.fine === 1 ? values.fineType : 0,
            updateTenants: values.updateTenant ? 1 : 0,
        });
    }
    const getInputClass = (isDisabled) => {
        return isDisabled
            ? "bg-gray-100 cursor-not-allowed" : "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12";
    };
    return (
        <Wrapper className="bg-white border border-gray-200 rounded-lg p-5 shadow-sm space-y-2">
            <div className="mb-0">
                <p className="text-sm font-semibold text-gray-800">
                    Fine Settings
                </p>
                <p className="text-xs text-gray-500">
                    Configure late payment rules for this property
                </p>
            </div>
            <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => (
                    <Form>
                        <Wrapper>
                            {/* Grace Period - MUI Select */}
                            <CombineInputGroup>
                                <InputGroup>
                                    <Label>Grace Period *</Label>
                                    <FormControl fullWidth>
                                        <Select
                                            className="px-2"
                                            id="gracePeriod"
                                            name="gracePeriod"
                                            value={values.gracePeriod}
                                            onChange={(e) => setFieldValue("gracePeriod", e.target.value)}
                                            onBlur={handleBlur}
                                            required
                                            displayEmpty
                                            sx={{
                                                height: "48px",
                                                borderRadius: "6px",
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#a3a3b9",
                                                },
                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#d1d5db",
                                                },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#0284C7",
                                                },
                                            }}

                                        >
                                            <MenuItem value="" disabled>
                                                <span className="text-gray-400">Select grace period</span>
                                            </MenuItem>
                                            {gracePeriod.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {touched.gracePeriod && errors.gracePeriod && (
                                        <p className="text-red-500 text-xs mt-1">{errors.gracePeriod}</p>
                                    )}
                                </InputGroup>

                                {/* Fine - MUI Select */}
                                <InputGroup>
                                    <Label>Fine </Label>
                                    <FormControl fullWidth>
                                        <Select
                                            className="px-2"
                                            id="fine"
                                            name="fine"
                                            value={values.fine}
                                            onChange={(e) => setFieldValue("fine", e.target.value)}
                                            onBlur={handleBlur}
                                            required
                                            displayEmpty
                                            sx={{
                                                height: "48px",
                                                borderRadius: "6px",
                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#a3a3b9",
                                                },
                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#d1d5db",
                                                },
                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#0284C7",
                                                },
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                <span className="text-gray-400">Select fine option</span>
                                            </MenuItem>
                                            {fineOptions.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {touched.fine && errors.fine && (
                                        <p className="text-red-500 text-xs mt-1">{errors.fine}</p>
                                    )}
                                </InputGroup>
                            </CombineInputGroup>
                            <CombineInputGroup>
                                {/* Fine Amount (Conditional) */}
                                {values.fine === 1 && (
                                    <>
                                        <InputGroup>
                                            <Label htmlFor="fineAmount">Fine Amount *</Label>
                                            <FieldWrapper>
                                                <Field
                                                    type="number"
                                                    name="fineAmount"
                                                    id="fineAmount"
                                                    value={values.fineAmount}
                                                    onChange={(e) => setFieldValue("fineAmount", e.target.value)}
                                                    required
                                                    min="0"
                                                    max="10000"
                                                    className={getInputClass(false)}
                                                />
                                            </FieldWrapper>
                                            {touched.fineAmount && errors.fineAmount && (
                                                <p className="text-red-500 text-xs mt-1">{errors.fineAmount}</p>
                                            )}
                                        </InputGroup>

                                        {/* Fine Type - MUI Select */}
                                        <InputGroup>
                                            <Label>Fine Type *</Label>
                                            <FormControl fullWidth>
                                                <Select
                                                    className="px-2"
                                                    id="fineType"
                                                    name="fineType"
                                                    value={values.fineType}
                                                    onChange={(e) => setFieldValue("fineType", e.target.value)}
                                                    onBlur={handleBlur}
                                                    required={values.fine === 1}
                                                    displayEmpty
                                                    sx={{
                                                        height: "48px",
                                                        borderRadius: "6px",
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "#a3a3b9",
                                                        },
                                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "#d1d5db",
                                                        },
                                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "#0284C7",
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="" disabled>
                                                        <span className="text-gray-400">Select fine type</span>
                                                    </MenuItem>
                                                    {fineTypeOptions.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            {touched.fineType && errors.fineType && (
                                                <p className="text-red-500 text-xs mt-1">{errors.fineType}</p>
                                            )}
                                        </InputGroup>
                                    </>
                                )}
                            </CombineInputGroup>
                            {/* Update for all tenants checkbox */}
                            <InputGroup>
                                {/* <CheckboxLabel>
                                    <CheckboxContainer>
                                        <HiddenCheckbox
                                            type="checkbox"
                                            checked={values.updateTenant}
                                            onChange={(e) => setFieldValue("updateTenant", e.target.checked)}
                                        />
                                        <StyledCheckbox $checked={values.updateTenant}>
                                            {values.updateTenant && <CheckIcon />}
                                        </StyledCheckbox>
                                    </CheckboxContainer>
                                    <LabelText>
                                        Update for all tenants
                                    </LabelText>
                                </CheckboxLabel> */}
                                <div className="flex items-center justify-between mt-2 p-3 rounded-md border border-gray-200 bg-gray-50">
                                    <div>
                                        <p className="text-sm font-medium text-gray-800">
                                            Apply to Existing Tenants
                                        </p>
                                        <p className="text-xs text-gray-500">
                                            Update fine settings for all current tenants
                                        </p>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => setFieldValue("updateTenant", !values.updateTenant)}
                                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${values.updateTenant ? "bg-primary-color" : "bg-gray-300"
                                            }`}
                                    >
                                        <span
                                            className={`inline-block h-4 w-4 transform rounded-full bg-white transition ${values.updateTenant ? "translate-x-6" : "translate-x-1"
                                                }`}
                                        />
                                    </button>
                                </div>
                            </InputGroup>
                        </Wrapper>

                        <BtnWrapper>
                            <SubmitBtn type="submit" disabled={editFineDetailsLoading}>
                                {editFineDetailsLoading ? "Updating..." : "Update"}
                            </SubmitBtn>
                        </BtnWrapper>
                    </Form>
                )}
            </Formik>
        </Wrapper>
    )
}

const BtnWrapper = tw.div`border-t border-gray-100 pt-4 flex justify-end`;
const SubmitBtn = tw.button`
text-sm  w-24  md:w-20 h-7 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-xs bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;
const FieldWrapper = tw.div`w-full`;
const CheckboxContainer = tw.div`relative flex items-center justify-center w-5 h-5`;
const HiddenCheckbox = tw.input`absolute opacity-0 w-0 h-0`;

const StyledCheckbox = tw.div`w-4 h-4 flex items-center justify-center border rounded transition-colors duration-150
    ${(p) => p.$checked
        ? 'bg-primary-color border-primary-color'
        : 'bg-white border-gray-300 group-hover:border-gray-400'
    }
`;
const CheckIcon = tw(FaCheck)`w-3 h-3 text-white`;
const CheckboxLabel = tw.label`flex items-center cursor-pointer group`;
const LabelText = tw.span`ml-2 text-sm text-gray-600 font-normal`;
export default PropertyFineDetail